/** @jsxImportSource @emotion/react */
import React from "react";
import { Button, Checkbox, Popover } from "antd";
import { SizeType } from "antd/lib/config-provider/SizeContext";
import { TooltipPlacement } from "antd/lib/tooltip";
import { EyeInvisibleOutlined } from "@ant-design/icons";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import * as Styles from "./styles";

export interface ToolboxColumnToggleProps {
  indeterminate: boolean;
  checkAll: boolean;
  options: string[];
  values: CheckboxValueType[];
  onCheckAllChange: (e: CheckboxChangeEvent) => void;
  onDisplayColumnChanged: (list: CheckboxValueType[]) => void;
  label?: string;
  selectAllLabel?: string;
  icon?: React.ReactNode;
  size?: SizeType;
  placement?: TooltipPlacement;
}

export const ToolboxColumnToggle: React.FC<ToolboxColumnToggleProps> = ({
  indeterminate,
  checkAll,
  options,
  values,
  onCheckAllChange,
  onDisplayColumnChanged,
  label = "Hide Column",
  selectAllLabel = "Select all items",
  icon = <EyeInvisibleOutlined />,
  size = "large",
  placement = "bottomRight",
}: ToolboxColumnToggleProps) => {
  return (
    <Popover
      placement={placement}
      trigger="hover"
      content={
        <>
          <Checkbox
            indeterminate={indeterminate}
            onChange={onCheckAllChange}
            checked={checkAll}
          >
            {selectAllLabel}
          </Checkbox>
          <br />
          <Checkbox.Group
            options={options}
            value={values}
            onChange={onDisplayColumnChanged}
            css={Styles.checkboxGroupStyle}
          />
        </>
      }
    >
      <Button size={size} icon={icon}>
        {label}
      </Button>
    </Popover>
  );
};
